/*
 * Copyright 2022-present terrestris GmbH & Co. KG
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */
import React, {
  useState
} from 'react';

import {
  faPrint,
  faSpinner
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';

import {
  Progress
} from 'antd';

import {
  PrintButton,
  PrintButtonProps
} from '@terrestris/react-geo/dist/Button/PrintButton/PrintButton';

import { useMap } from '@terrestris/react-util';

import './ProjectPrintButton.less';
import { pdfPrintFunc } from './PrintFunction';

export const ProjectPrintButton: React.FC<Partial<PrintButtonProps>> = (): React.JSX.Element => {
  const [progress, setProgress] = useState<number>(0);

  const map = useMap();

  const isLoading = progress > 0 && progress < 100;

  if (!map) {
    return <></>;
  }

  return (
    <div className='printbutton'>
      <PrintButton
        // todo: make configurable
        tooltip='Kartenausschnitt als PDF drucken'
        tooltipProps={{
          mouseEnterDelay: .1,
          placement: 'right'
        }}
        pdfPrintFunc={pdfPrintFunc}
        onProgressChange={setProgress}
        outputFileName='Kartendruck Solar- und Gründachpotenzialanalyse'
        legendTitle='Legende'
        title='Solar- und Gründachpotenzialanalyse'
        mapSize={[277, 170, 'mm']}
        northArrow={false}
        // @ts-ignore // todo!!!
        format='pdf'
        icon={
          <FontAwesomeIcon
            icon={isLoading ? faSpinner : faPrint}
          />
        }
      />
      {
        isLoading &&
        <Progress
          size='small'
          showInfo={false}
          percent={progress}
        />
      }
    </div>
  );
};

export default ProjectPrintButton;
